
import { User} from "../../../../model/user/user.model";
import { BusinessContact } from '../../../../model/user/businesscontact.model';
import { PasswordStrengthResult } from "../../../../model/common/password";
import { IValidationMessages, Result } from '../../../../model/common/error/error.model';
import { UserService } from "../../../../shared/services/user/user.service";
import { WindowService, IWindowOption } from "../../../../shared/services/common/window/window.service";
import { MessageService } from "../../../../shared/services/common/message.service";
import { Path } from "../../../../app.config";
import { Constant } from "../../../../model/common/constant";

let template = require('./resetpassword.html');

export class ResetPasswordComponent implements ng.IComponentController {
    public user: User;
    public resetPasswordFormVisible: boolean;
    public resetPasswordForm: ng.IFormController;
    public userService: UserService;
    public isPasswordVisible: boolean;
    public passwordStrengthResult: PasswordStrengthResult;
    public userdata: User;
    public identifier: string;
    public windowService: WindowService;
    public msgService: MessageService;
    public $translate: ng.translate.ITranslateService;
    public $rootScope: angular.IRootScopeService;

    public static $inject: Array<string> = ["$translate", "UserService", "WindowService", "MessageService", "$rootScope"];
    constructor($translate: ng.translate.ITranslateService, userService: UserService, windowService: WindowService, msgService: MessageService, $rootScope: angular.IRootScopeService) {
        this.$translate = $translate;
        this.userService = userService;
        this.windowService = windowService;
        this.msgService = msgService;
        this.$rootScope = $rootScope;


    }
    $onInit() {
        try {
            if (this.identifier)
                this.user = new User(this.userdata);
            else
                this.user = this.userdata;
        }
        catch (e) {
            throw new Error("Invalid data passed.");
        }
        this.isPasswordVisible = false;
        this.passwordStrengthResult = new PasswordStrengthResult();
        this.resetPasswordFormVisible = true;
    }
    onSubmitResetPasswordForm() {
        this.$rootScope.$broadcast(Constant.Event.ChangePasswordFormSubmit);
        
        if (this.resetPasswordForm.$valid && this.passwordStrengthResult.Status) {
            if (!this.identifier) {
                this.userService.updateUserPassword(this.user).then((res: ng.IHttpPromiseCallbackArg<Result>) => {
                    if (res.data.Status) {
                        this.resetPasswordFormVisible = false;
                        if(res.data.Data) {
                            this.user.BusinessContact.Email = res.data.Data;
                        }
                    }
                    else {
                        let validationMsg: Array<IValidationMessages> = [];

                        res.data.ValidationResults.forEach(t =>
                            validationMsg.push({ Key: t.ErrorCode, Message: t.ErrorMessage } as IValidationMessages));

                        this.windowService.showErrorWindow({
                            TextContentList: this.msgService.getLocalisedMessageList(validationMsg)
                        } as IWindowOption);

                    }
                });
            }
            else {
                this.userService.resetPassword(this.user, this.identifier).then((res: ng.IHttpPromiseCallbackArg<Result>) => {
                    if (res.data.Status) {
                        this.resetPasswordFormVisible = false;
                        if(res.data.Data) {
                            this.user.BusinessContact.Email = res.data.Data;
                        }
                    }
                    else {
                        let validationMsg: Array<IValidationMessages> = [];

                        res.data.ValidationResults.forEach(t =>
                            validationMsg.push({ Key: t.ErrorCode, Message: t.ErrorMessage } as IValidationMessages));

                        this.windowService.showErrorWindow({
                            TextContentList: this.msgService.getLocalisedMessageList(validationMsg)
                        } as IWindowOption);

                    }
                });
            }
        }
    }
    redirectToLogin() {
        window.location.href = sessionStorage.getItem('loginUrl') ? sessionStorage.getItem('loginUrl') : Path.Provider.ApplicationPath;
    }
}

export let resetPasswordComponent: ng.IComponentOptions = {
    template: template.default,
    transclude: false,
    controllerAs: Constant.CtrlAs,
    controller: ResetPasswordComponent,
    bindings: {
        userdata: Constant.Binding.ONEWAY,
        identifier: Constant.Binding.VALUE
    }
};

